
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import frCookieConsent from './src/locales/fr/cookieconsent.json'
import enCookieConsent from './src/locales/en/cookieconsent.json'

// Umami config
const UMAMI_SRC = 'https://cloud.umami.is/script.js'
const UMAMI_WEBSITE_ID = '352f1ab3-4581-4836-8a3c-b2dfb657b429'

config.autoAddCss = false

const cookieConsentTranslations = {
  fr: frCookieConsent,
  en: enCookieConsent,
}

// Fast locale redirect from "/" to "/fr/" or "/en/" to avoid blank first render
export const onClientEntry = () => {
  if (typeof window === 'undefined') return

  const path = window.location.pathname
  if (path === '/' || path === '/index.html') {
    const lang = (navigator.language || navigator.userLanguage || '').toLowerCase()
    const target = lang.startsWith('fr') ? '/fr/' : '/en/'
    if (path !== target) {
      window.location.replace(target)
      return
    }
  }

  const pathSegments = path.split('/').filter(Boolean)
  const currentLang = pathSegments[0] === 'en' ? 'en' : 'fr'

  const initCookieConsent = () => {
    import('vanilla-cookieconsent').then((CookieConsent) => {
      const loadUmami = () => {
        if (window.umami) return
        const existing = document.querySelector(`script[data-website-id="${UMAMI_WEBSITE_ID}"]`)
        if (existing) return
        CookieConsent.loadScript(UMAMI_SRC, {
          'data-website-id': UMAMI_WEBSITE_ID,
          async: 'true',
          defer: 'true',
        }).catch(() => {})
      }

      const enableAnalyticsIfAllowed = (cookie = {}) => {
        if ((cookie.categories || []).includes('analytics')) loadUmami()
      }

      CookieConsent.run({
        autoclear_cookies: true,
        page_scripts: true,
        categories: {
          necessary: { enabled: true, readOnly: true },
          analytics: { enabled: false },
        },
        language: {
          default: currentLang,
          translations: cookieConsentTranslations,
        },
        onConsent: ({ cookie }) => enableAnalyticsIfAllowed(cookie),
        onChange:  ({ cookie }) => enableAnalyticsIfAllowed(cookie),
      }).then(() => {
        enableAnalyticsIfAllowed(CookieConsent.getCookie())
      })
    })
  }

  const scheduleInit = () => {
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(initCookieConsent, { timeout: 3000 })
    } else {
      setTimeout(initCookieConsent, 300)
    }
  }

  if (document.readyState === 'complete') {
    scheduleInit()
  } else {
    window.addEventListener('load', scheduleInit, { once: true })
  }
}
